import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BausteinContentConfig} from '../../model/baustein-content-config';
import {DropdownInput, RadioInput} from 'src/app/model/structured-content-models';
import {TariffConfigurationService} from 'src/app/service/tariff-configuration-service';
import {StructuredContentService} from 'src/app/service/structured-content.service';
import {ContextType} from 'src/app/service/price-box-communication.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {TrackingService} from 'src/app/service/tracking.service';
import {ApiService} from 'src/app/service/api.service';
import {TariffOptionConfiguration} from '../../model/tariff-option-configuration';
import {PricesWrapper} from '../../model/prices-wrapper';
import { FieldConfiguration } from 'src/app/model/field-configuration';

@Component({
  selector: 'app-baustein-content',
  templateUrl: './baustein-content.component.html',
  styleUrls: ['./baustein-content.component.scss'],
  animations: [
    trigger('childAnimation', [
      // ...
      state('open', style({
        opacity: 1,
        fontSize: 'initial',
        maxHeight: '999em'
      })),
      state('closed', style({
        opacity: 0,
        maxHeight: 0,
        fontSize: 0
      })),
      transition('open => closed', [
        animate('0s')
      ]),
      transition('closed => open', [
        animate('0.55s')
      ]),
    ]),
  ],
})

export class BausteinContentComponent implements OnInit {

  @Input() ContentConfig: BausteinContentConfig;
  @Input() tariffId: string;
  @Input() headerTitle: string;
  @Output() tariffChanged = new EventEmitter();

  public radioConfigs: Array<RadioInput>;
  public dropdownConfigs: Array<DropdownInput>;

  public tariffConfigSvc: TariffConfigurationService;
  public scSvc: StructuredContentService;
  public isMoreContentOpen: boolean;
  public apiSvc: ApiService;

  private trackingService: TrackingService;

  constructor(tariffConfigSvc: TariffConfigurationService, scSvc: StructuredContentService,
              trackingService: TrackingService, apiSvc: ApiService) {
    this.tariffConfigSvc = tariffConfigSvc;
    this.scSvc = scSvc;
    this.trackingService = trackingService;
    this.apiSvc = apiSvc;
  }

  getTariffOption(): TariffOptionConfiguration {
    return this.tariffConfigSvc.getTariffOptionById(this.tariffId);
  }

  hasOptionsToShow(): boolean {
    const toc: TariffOptionConfiguration =this.getTariffOption();
    if(this.hasVisibleFields(toc, this.dropdownConfigs) || this.hasVisibleFields(toc, this.radioConfigs)) return true;
    return false;
  }

  hasVisibleFields(toc: TariffOptionConfiguration, configs: Array<{fieldName: string}>): boolean {
    for(let ddi of configs) {
      const fc = toc.fields[ddi.fieldName] as FieldConfiguration;
      if(fc.visible) return true;
    }
    return false;
  }

  getPrices(): PricesWrapper {
    return this.tariffConfigSvc.getPricesById(this.tariffId);
  }

  getPriceAsString(): string {
    const pricesWrapper = this.getPrices();

    if (this.ContentConfig.context === ContextType.VMK) {
      const priceStringUkv = this.getRoundedPriceAsString(pricesWrapper.priceUkv);
      const priceStringBk = this.getRoundedPriceAsString(pricesWrapper.priceBk);
      return priceStringUkv + ' / ' + priceStringBk;
    } else {
      const price = this.ContentConfig.context === ContextType.UKV ? pricesWrapper.priceUkv : pricesWrapper.priceBk;
      return  this.getRoundedPriceAsString(price);
    }
  }

  getRoundedPriceAsString(price: number): string {
    return price.toLocaleString(undefined, { minimumFractionDigits: 2 });
  }

  ngOnInit() {

    this.radioConfigs = new Array<RadioInput>();
    this.dropdownConfigs = new Array<DropdownInput>();

    if (this.ContentConfig.selectionFields) {
      for (const selectionField of this.ContentConfig.selectionFields) {
        if (selectionField.dropdownInput) {
          this.dropdownConfigs.push(selectionField.dropdownInput);
        }
        if (selectionField.radioInput) {
          this.radioConfigs.push(selectionField.radioInput);
        }
      }
    }

    if (this.ContentConfig.additionalText) {
      this.isMoreContentOpen = this.ContentConfig.additionalText.initialVisibility;
    }
  }

  onTariffChanged() {
    if (this.tariffChanged) {
      this.tariffChanged.emit(this.tariffId);
    }
  }

  toggleMoreContent() {
    this.isMoreContentOpen = !this.isMoreContentOpen;

    if (this.isMoreContentOpen) {
      this.trackingService.trackShowMorelick(this.headerTitle);
    }
  }
}
